<template>
  <DialogWrapper
    close-on-cancel
    class="group-add-dialog"
    :titleI18nKey="`${i18nPrefix}.title.add`"
    :show.sync="show"
    :loading="loading"
    @save="handleSave"
  >
    <div class="content">
      <div v-if="!hiddenCurrentGroup && !hiddenTalentPoolGroup" class="tip-message">{{ $t(`${i18nPrefix}.message.addGroupTip`) }}</div>
      <WrappedForm
        class="add-group-form"
        ref="form"
        hideRequiredAsterisk
        :model="groupInfo"
        :formLines="formLines"
      ></WrappedForm>
    </div>
  </DialogWrapper>
</template>

<script>
import WrappedForm from '@/components/formEditor/wrappedForm.vue'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import GroupSelector from '../components/candidateGroupSelector.vue'
import _ from 'lodash'

export default {
  components: {
    DialogWrapper,
    WrappedForm
  },
  props: {
    groupList: {
      type: Array,
      required: true
    },
    talentPoolGroupList: {
      type: Array,
      required: true
    },
    hiddenCurrentGroup: {
      type: Boolean,
      default: false
    },
    isOperator: {
      type: Boolean,
      default: false
    },
    hiddenTalentPoolGroup: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidateGroup',
      show: false,
      loading: false,
      groupInfo: {}
    }
  },
  computed: {
    formLines () {
      const lines = {
        currentGroup: {
          elType: GroupSelector,
          label: this.$t(`${this.i18nPrefix}.label.currentGroup`),
          rules: [{ validator: this.validateCurrentGroup, trigger: 'change' }],
          props: { groupList: this.groupList },
          hidden: this.hiddenCurrentGroup
        },
        talentPoolGroup: {
          elType: GroupSelector,
          label: this.hiddenCurrentGroup ? this.$t(`${this.i18nPrefix}.label.groupName`) : this.$t(`${this.i18nPrefix}.label.talentPoolGroup`),
          rules: [{ validator: this.validateTalentPoolGroup, trigger: 'change' }],
          props: { groupList: this.talentPoolGroupList },
          hidden: this.hiddenTalentPoolGroup
        }
      }
      return lines
    },
    from () {
      return this.$refs.from
    }
  },
  created () {

  },
  methods: {
    openDialog () {
      this.show = true
    },
    closeDialog () {
      this.show = false
    },
    clearForm () {
      this.groupInfo = {}
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    validateCurrentGroup (rule, value, callback) {
      if (!value && !this.groupInfo.talentPoolGroup) {
        callback(new Error(this.$t('common.message.requiredFormField')))
        return
      }
      if (value && !value.id) {
        const found = _.findIndex(this.groupList, { text: value.text }) > -1
        if (found) {
          callback(new Error(this.$t(`${this.i18nPrefix}.message.existedGroupName`)))
          return
        }
      }
      callback()
    },
    validateTalentPoolGroup (rule, value, callback) {
      if (!value && !this.groupInfo.currentGroup) {
        callback(new Error(this.$t('common.message.requiredFormField')))
        return
      }
      if (value && !value.id) {
        const found = _.findIndex(this.talentPoolGroupList, { text: value.text }) > -1
        if (found) {
          callback(new Error(this.$t(`${this.i18nPrefix}.message.existedGroupName`)))
          return
        }
      }
      callback()
    },
    async handleSave () {
      if (this.loading) {
        return
      }
      const isValid = await this.$refs.form.submit()
      if (!isValid) {
        return
      }
      this.loading = true
      if (this.isOperator) {
        this.$emit('saveOperator', this.groupInfo, close => {
          this.loading = false
          if (close) {
            this.closeDialog()
          }
        })
      } else {
        this.$emit('save', this.groupInfo, close => {
          this.loading = false
          if (close) {
            this.closeDialog()
          }
        })
      }
    }
  },
  watch: {
    show () {
      if (this.show) {
        this.clearForm()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.group-add-dialog {
  .add-group-form {
    margin-top: 24px;
  }
}
</style>
